import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    Autocomplete,
    Box,
    Grid,
    Grow,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Typography,
} from "@mui/material";

import {
    getRoleGroupList,
    addRoleGroup,
    updateRoleGroup,
    deleteRoleGroup
} from "../../store/actions/roleGroupActions";

import { commonSort } from "../../common";
import AddButton from "../../components/AddButton/AddButton";
import SearchBar from "../../components/SearchBar/SearchBar";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

export default function MaintenanceType() {
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    const { roleGroup } = useSelector(
        (roleGroup) => roleGroup
    );

    const [pageLoaded, setPageLoaded] = useState(false);
    const [editable, setEditable] = useState(false);
    const [editableRow, setEditableRow] = useState("");

    const [isAddDisable, setIsAddDisable] = useState(true);

    //tabloyla alakali stateler
    const [plantList, setPlantList] = useState([]);

    //Sayfanin ilk acilmasiyla alakali stateler
    const [initialRows, setInitialRows] = useState([]);
    let [rows, setRows] = useState([]);
 
    useEffect(() => {
        loadHandler();
    }, []);


    useEffect(() => {
        if (roleGroup?.RoleGroupList?.resultObject?.length) {
            setInitialRows(roleGroup.RoleGroupList.resultObject);
            setRows(roleGroup.RoleGroupList.resultObject);
            roleGroup.RoleGroupList = {};
            setPageLoaded(true);
        }

        if (roleGroup.isTaskUpdatedRoleGroup) {
            setEditableRow(false);
            setDisableButton(false);
            loadHandler();
        }
    }, [roleGroup]);

    const loadHandler = () => {
        dispatch(getRoleGroupList());
    };

    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 1 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return <TableCell align="center">{t("Actions")}</TableCell>;
            } else {
                return isSortingAction ? (
                    <TableCell align="center" id={`rg_TableHead_${index}`}>
                        <TableSortLabel
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() =>
                                handleSort(cloneObject(initialRows), item.id)
                            }
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

     //dynamic sort function
     let [sortOrder, setSortOrder] = useState();
     let [sortColumn, setSortColumn] = useState();

     const handleSort = (row, column) => {
         const sortedList = commonSort(row, column);
         setSortOrder(sortedList[0]);
         setSortColumn(sortedList[1]);
         setInitialRows(sortedList[2]);
         setRows(sortedList[2]);
     };

     const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

     // Pagination
     const [currentPage, setCurrentPage] = useState(0);
     const [rowsPerPage, setRowsPerPage] = useState(20);
     const handleChangePage = (_event, newPage) => {
         setCurrentPage(newPage);
     };
 
     const handleChangeRowsPerPage = (event) => {
         setRowsPerPage(+event.target.value);
         setCurrentPage(0);
     };

    //set edited rows
    const setRowHandler = (value, obj, updatedRow) => {
        const index = rows.indexOf(updatedRow);
        if (updatedRow.id != "") {
            const row = rows[index];
            row[obj] = value;
            rows[index] = row;
            setRows(rows);
        } else {
            const row = rows[index];
            row[obj] = value;
            setRows(rows);
        }
        if (value.length > 0) {
            if (obj === "code") {
                setError({ ...error, roleGroupCodeError: "" });
            } else if (obj === "name") {
                setError({ ...error, roleGroupNameError: "" });
            }
            
        } else {
            if (obj === "code") {
                setError({ ...error, roleGroupCodeError: t("RoleGroupCodeValidation") });
            } else if (obj === "name") {
                setError({ ...error, roleGroupNameError: t("RoleGroupNameValidation") });
            }
        }

    };

    const updateAddHandler = (row) => {
        // update
        if (row.id !== "") {
            const data = {
                id: row.id,
                code: row.code,
                name: row.name,
                nameEN: row.nameEN,
                nameRU: row.nameRU,
                nameRO: row.nameRO,
                breakdownReasonGroupLocalizationName: row.breakdownReasonGroupLocalizationName,
                status: 1,
            };
            dispatch(updateRoleGroup(data));
        }
        // add
        else {
            const data = {
                code: row.code,
                name: row.name,
                nameEN: row.nameEN,
                nameRU: row.nameRU,
                nameRO: row.nameRO,
                breakdownReasonGroupLocalizationName: row.breakdownReasonGroupLocalizationName,
            };
          
            dispatch(addRoleGroup(data));
        }
    };

    const disableEditHandler = () => {
        filterData(filterText);
        setEditable(false);
        //enable edit button
        setDisableButton(false);

        setError({
            roleGroupCodeError: t("RoleGroupCodeValidation"),
            roleGroupNameError: t("RoleGroupNameValidation"),
        });
    };

    //filter table
    const [filterText, setFilterText] = useState("");
    const [disableButton, setDisableButton] = useState(false);

    // Filter table
    const filterData = (value) => {
        const newFilteredText = value.toLowerCase();
        setFilterText(newFilteredText);
        let filteredItems = cloneObject(initialRows).filter((item) => item.code.toLowerCase().includes(newFilteredText) || item.name.toLowerCase().includes(newFilteredText));
        setRows(filteredItems);
        setDisableButton(false);
    };

    useEffect(() => {
        filterData(filterText);
    }, [initialRows]);

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const deleteButtonHandler = (row) => {
        setDeletedRow(row);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    const enableEditHandler = (row) => {
        if (disableButton || editable) {
            filterData(filterText);
        }
        setDisableButton(true);
        setEditableRow(row.id);
        setEditable(true);

        setError({
            roleGroupCodeError: "",
            roleGroupNameError: "",
        });
    };

    //add blank row for new plant addition
    const addBlankRowHandler = () => {
        setCurrentPage(0);
        setDisableButton(true);
        const addedBlankRow = [
            {
                id: "",
                code: "",
                name: "",
            },
        ];

        rows = addedBlankRow.concat(rows);
        setEditableRow(addedBlankRow[0].id);
        setEditable(true);
        setRows(rows);
    };

    const deleteHandler = (row) => {
        toggleModal();
        const data = {
            id: row.id,
            code: row.code,
            name: row.name,
            nameEN: row.nameEN,
            nameRU: row.nameRU,
            breakdownReasonGroupLocalizationName: row.breakdownReasonGroupLocalizationName,
        };
        dispatch(deleteRoleGroup(data));
    };

    const [error, setError] = useState({
        roleGroupCodeError: t("RoleGroupCodeValidation"),
        roleGroupNameError: t("RoleGroupNameValidation"),
    });

    useEffect(() => {
        if (error.roleGroupCodeError === "" && error.roleGroupNameError === "") {
            setIsAddDisable(false);
        } else {
            setIsAddDisable(true);
        }
    }, [error]);

    let history = useHistory();
    const openDetailPage = (id) => {
            history.push("/addfunctiontorolegroup?id=" + id);
    };



    return (
        <StyledTableDiv>
            <h1>
                {t("RoleGroup")} {t("List")}{" "}
            </h1>
            <AddButton
                onClick={() => addBlankRowHandler()}
                disabled={disableButton}
            />
            {pageLoaded === true ? (
                <Grid
                    container
                    spacing={4}
                    alignItems="center"
                    justifyContent="center"
                    sx={{ marginBottom: 4 }}
                >
                    <Grid item xs={12} sm={12} md={4}>
                        <SearchBar value={filterText} onChange={(newValue) => setFilterText(newValue)} onRequestSearch={(value) => filterData(value)} />
                    </Grid>
                </Grid>
            ) : null}
            <Box m={2} />
            {rows.length > 0 ? (
                <Grow
                    in={true}
                    style={{ transformOrigin: "0 0 0" }}
                    {...{ timeout: 1000 }}
                >
                    <TableContainer component={Paper}>
                    <Table id="rg_Table" aria-label="simple table">
                                <TableHead id="rg_TableHead">
                                    <TableRow id="rg_TableRow">
                                        {renderTableCell([
                                            { id: "id", label: t("ID") },
                                            { id: "code", label: `${t("RoleGroup")} ${t("Code")}` },
                                            { id: "name", label: `${t("RoleGroup")} ${t("Name")}` },
                                            { id: "Actions", label: t("Actions") },
                                        ])}
                                    </TableRow>
                                </TableHead>
                                <TableBody id="rg_TableBody">
                                    {rows.slice(
                                        currentPage * rowsPerPage,
                                        currentPage * rowsPerPage + rowsPerPage
                                        ).map((row, index) => (
                                        <React.Fragment key={row.id}>
                                        <TableRow id={`rg_TableRow_${index}`} key={row.id}>
                                            <TableCell id={`rg_TableCell_${index}`} align="center">
                                                {row.id}
                                            </TableCell>
                                            <TableCell id={`rg_TableCell_1_${index}`} align="center">
                                                {editable && editableRow === row.id ? (
                                                    <TextField
                                                        id={`rg_TableCell_1_TextField_${index}`}
                                                        onInput={(e) => setRowHandler(e.target.value, "code", row)}
                                                        defaultValue={row.code}
                                                        variant="outlined"
                                                        error={error.roleGroupCodeError.length > 0}
                                                        helperText={error.roleGroupCodeError} 
                                                        FormHelperTextProps ={{id: "rg_val1"}}
                                                    />
                                                ) : (
                                                    row.code
                                                )}
                                            </TableCell>
                                            <TableCell id={`rg_TableCell_2_${index}`} align="center">
                                                {editable && editableRow === row.id ? (
                                                    <TextField
                                                        id={`rg_TableCell_2_TextField_${index}`}
                                                        onInput={(e) => setRowHandler(e.target.value, "name", row)}
                                                        defaultValue={row.name}
                                                        variant="outlined"
                                                        error={error.roleGroupNameError.length > 0}
                                                        helperText={error.roleGroupNameError} 
                                                        FormHelperTextProps ={{id: "rg_val2"}}
                                                    />
                                                ) : (
                                                    row.name
                                                )}
                                            </TableCell>
                                            <TableButtons
                                                editable={editable}
                                                addDisabled={isAddDisable}
                                                editableRow={editableRow}
                                                row={row}
                                                updateAddHandler={() => updateAddHandler(row)}
                                                disableEditHandler={() => disableEditHandler()}
                                                enableEditHandler={() => enableEditHandler(row)}
                                                deleteButtonHandler={() => deleteButtonHandler(row)}
                                                openDetailPage={() => openDetailPage(row.id)}
                                                detail={true}
                                            />
                                        </TableRow>
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </Table>

                        <TablePagination
                            rowsPerPageOptions={[20, 50, 100]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={currentPage}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grow>
            ) : null}
            <Modal
                title={t("Delete")}
                content={t("WillYouDoTransaction")}
                approved={() => deleteHandler(deletedRow)}
                isModalOpen={isModalOpen}
                toggle={toggleModal}
            />
            <LoadingBackdrop id="rg_lbd" />
        </StyledTableDiv>
    );
}
